import clsx from 'clsx'
import { merge } from 'lodash-es'
import { type HTMLMotionProps, motion } from 'motion/react'
import { type Ref } from 'react'
import styles from './ClickWrapper.module.css'

export interface ClickWrapperProps extends HTMLMotionProps<'div'> {
	ref?: Ref<HTMLDivElement>
}

export default function ClickWrapper({ className, ref, ...props }: ClickWrapperProps) {
	return (
		<motion.div
			{...props}
			whileTap={merge(
				{},
				{
					scale: 0.98,
				},
				props.whileTap
			)}
			ref={ref}
			className={clsx(styles.root, className)}
		/>
	)
}
